module.exports = shared.Bluebird;